import { useEffect } from 'react';

/**
 * Hook to handle Alt+Key shortcuts for menu bar
 * @param shortcuts - Map of key to trigger element selector or callback
 */
export function useMenuBarShortcuts(shortcuts: Record<string, () => void>) {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      // Check if Alt key is pressed (without Ctrl, Shift, or Meta)
      if (event.altKey && !event.ctrlKey && !event.shiftKey && !event.metaKey) {
        const key = event.key.toLowerCase();
        const action = shortcuts[key];

        if (action) {
          event.preventDefault();
          event.stopPropagation();

          action();
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [shortcuts]);
}
